var ReservationSegmentCheckInErrors = {
  
  general: function (errors) {
    var err = [];
    
    if (errors && errors.length) {
      for (var i = 0, ilen = errors.length; i < ilen; i++) {
        err.push(errors[i]);
      }
    }

    return err;
  },
};

export default ReservationSegmentCheckInErrors








